exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".master-document-form .btn,.master-document-form .form-control,.master-document-form label{font-size:12px}.master-document-form .form-control{height:30px;padding:2px 4px;line-height:1.5}.master-document-form .btn{padding:4px 8px}.master-document-table{font-size:13px}.master-document-table th{background:#d8e2f2;color:#555;text-align:center;vertical-align:middle!important}.master-document-table td{text-align:center;vertical-align:middle!important;padding:5px 10px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-b0263d28","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/views/manual-forms/upload-masterpage.vue
// module id = 748
// module chunks = 27